import client from "../client";
import { postSubscriptionConfig } from "./postSubscriptionConfig";

const postSubscription = (authorization?: string, origin?: string) => {
  return client({
    ...postSubscriptionConfig(authorization, origin),
  });
};

export default { postSubscription };
